import React from "react";
import Headers from "../../../components/Headers";
import { Tabs, Row, Col, Input, Button, Table, message } from "antd";
import { Link } from "react-router-dom";
import {
  fetchAliPayList,
  fetchRoutingUnbind,
  fetchRoutingBind,
  fetchAliPayUnBind,
  fetchAliPayBind,
  fetchWeChatList,
} from "../../../api/capitalAccount";
import NProgress from "nprogress";

const BreadCrumbData = [
  { path: "/page/capitalaccount", name: "资金账户管理" },
  { path: "/page/capitalaccount/businessaccount", name: "商户账户" },
];
const { TabPane } = Tabs;
const { Column } = Table;
class BusinessAccount extends React.Component {
  state = {
    zhifubaoList: [],
    zhifubaoListQuery: {
      type: "ALIPAY",
      companyName: "",
      pageNum: 1,
      pageSize: 10,
    },
    zhifubaoTotal: 0,
    weixinList: [],
    weixinListQuery: {
      type: "WECHAT",
      companyName: "",
      pageNum: 1,
      pageSize: 10,
    },
    weixinTotal: 0,
  };
  async componentDidMount() {
    NProgress.start();
    await this.getAliPayList();
    await this.getWeChatList();
    NProgress.done();
  }
  getAliPayList = () => {
    fetchAliPayList(this.state.zhifubaoListQuery).then((res) => {
      this.setState({
        zhifubaoList: res.data.list,
        zhifubaoTotal: res.data.total,
      });
    });
  };
  getWeChatList = () => {
    fetchWeChatList(this.state.weixinListQuery).then((res) => {
      this.setState({
        weixinList: res.data.list,
        weixinTotal: res.data.total,
      });
    });
  };
  zhifubaoBusinessChange = (e) => {
    this.setState({
      zhifubaoListQuery: {
        ...this.state.zhifubaoListQuery,
        companyName: e.target.value,
      },
    });
  };
  zhifubaoSearch = () => {
    this.setState(
      {
        zhifubaoListQuery: { ...this.state.zhifubaoListQuery, pageNum: 1 },
      },
      () => this.getAliPayList()
    );
  };
  weixinBusinessChange = (e) => {
    this.setState({
      weixinListQuery: {
        ...this.state.weixinListQuery,
        companyName: e.target.value,
      },
    });
  };
  weixinSearch = () => {
    this.setState(
      {
        weixinListQuery: { ...this.state.weixinListQuery, pageNum: 1 },
      },
      () => this.getWeChatList()
    );
  };
  unBind = (type, row) => {
    fetchAliPayUnBind({
      customerId: row.customerId,
      companyId: row.companyId,
    }).then((res) => {
      if (res.success) {
        if (res.data) {
          message.success("解绑成功");
          this.getAliPayList();
        } else {
          message.error("解绑失败");
        }
      }
    });
  };
  bind = (type, row) => {
    fetchAliPayBind({
      customerId: row.customerId,
      companyId: row.companyId,
    }).then((res) => {
      if (res.success) {
        if (res.data) {
          message.success("绑定成功");
          this.getAliPayList();
        } else {
          message.error("绑定失败");
        }
      }
    });
  };
  render() {
    const {
      zhifubaoList,
      zhifubaoListQuery,
      zhifubaoTotal,
      weixinList,
      weixinListQuery,
      weixinTotal,
    } = this.state;

    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="salesData">
          <Tabs
            style={{ width: "100%" }}
            defaultActiveKey={this.props.location.state ? "2" : "1"}
          >
            <TabPane tab="支付宝分账" key="1">
              <div
                style={{
                  padding: "16px 0",
                  backgroundColor: "#fff",
                  height: 744,
                }}
              >
                <Row style={{ padding: "0 24px" }}>
                  <Col span={6} style={{ marginRight: 20 }}>
                    <Input
                      placeholder="商户名称"
                      onChange={this.zhifubaoBusinessChange}
                      allowClear
                    ></Input>
                  </Col>
                  <Col span={6}>
                    <Button type="primary" onClick={this.zhifubaoSearch}>
                      搜索
                    </Button>
                  </Col>
                </Row>
                <div className="lineBetween"></div>
                <Table
                  style={{ padding: "0 24px" }}
                  rowKey="customerId"
                  dataSource={zhifubaoList}
                  // locale={{ emptyText: "暂无商户" }}
                  pagination={{
                    showTotal: () => `共${zhifubaoTotal}条`,
                    total: zhifubaoTotal,
                    current: zhifubaoListQuery.pageNum,
                    pageSize: zhifubaoListQuery.pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "40", "100"],
                    onChange: (page, pageSize) => {
                      this.setState(
                        {
                          zhifubaoListQuery: {
                            ...zhifubaoListQuery,
                            pageNum: page,
                          },
                        },
                        () => this.getAliPayList()
                      );
                    },
                    onShowSizeChange: (current, pageSize) => {
                      this.setState(
                        {
                          zhifubaoListQuery: {
                            ...zhifubaoListQuery,
                            pageSize,
                            pageNum: 1,
                          },
                        },
                        () => this.getAliPayList()
                      );
                    },
                  }}
                >
                  <Column
                    title="商户名称"
                    dataIndex="companyName"
                    key="companyName"
                  />
                  <Column title="UserID" dataIndex="userId" key="userId" />
                  <Column
                    title="状态"
                    dataIndex="status"
                    key="status"
                    render={(text) => {
                      return text === "BIND" ? "已绑定" : "未绑定";
                    }}
                  />

                  <Column
                    title="操作"
                    render={(text, record) => {
                      return text.status === "BIND" ? (
                        <a onClick={() => this.unBind("ALIPAY", text)}>解绑</a>
                      ) : (
                        <a onClick={() => this.bind("ALIPAY", text)}>绑定</a>
                      );
                    }}
                  />
                </Table>
              </div>
            </TabPane>
            <TabPane tab="微信分账" key="2">
              <div
                style={{
                  padding: "16px 0",
                  backgroundColor: "#fff",
                  height: 744,
                }}
              >
                <Row style={{ padding: "0 24px" }}>
                  <Col span={6} style={{ marginRight: 20 }}>
                    <Input
                      placeholder="商户名称"
                      onChange={this.weixinBusinessChange}
                      allowClear
                    ></Input>
                  </Col>
                  <Col span={6}>
                    <Button type="primary" onClick={this.weixinSearch}>
                      搜索
                    </Button>
                  </Col>
                </Row>
                <div className="lineBetween"></div>
                <Table
                  style={{ padding: "0 24px" }}
                  rowKey="customerId"
                  dataSource={weixinList}
                  pagination={{
                    showTotal: () => `共${weixinTotal}条`,
                    total: weixinTotal,
                    current: weixinListQuery.pageNum,
                    pageSize: weixinListQuery.pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "40", "100"],
                    onChange: (page, pageSize) => {
                      this.setState(
                        {
                          weixinListQuery: {
                            ...weixinListQuery,
                            pageNum: page,
                          },
                        },
                        () => this.getWeChatList()
                      );
                    },
                    onShowSizeChange: (current, pageSize) => {
                      this.setState(
                        {
                          weixinListQuery: {
                            ...weixinListQuery,
                            pageSize,
                            pageNum: 1,
                          },
                        },
                        () => this.getWeChatList()
                      );
                    },
                  }}
                >
                  <Column
                    title="商户名称"
                    dataIndex="companyName"
                    key="companyName"
                  />
                  <Column title="商户ID" dataIndex="mchId" key="mchId" />
                  {/* <Column
                    title="状态"
                    dataIndex="status"
                    key="status"
                    render={text => {
                      return text === "BIND" ? "已绑定" : "未绑定";
                    }}
                  />

                  <Column
                    title="操作"
                    render={(text, record) => {
                      return text.status === "BIND" ? (
                        <a onClick={() => this.unBind("WECHAT", text)}>解绑</a>
                      ) : (
                        <a onClick={() => this.bind("WECHAT", text)}>绑定</a>
                      );
                    }}
                  /> */}
                  <Column
                    title="操作"
                    render={(text, record) => {
                      return (
                        <Link
                          to={`/page/capitalaccount/businessaccount/detail/${text.companyId}`}
                        >
                          查看详情
                        </Link>
                      );
                    }}
                  />
                </Table>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}
export default BusinessAccount;
